<template>
  <div class="avue-tags top-tags">
    <!-- tag盒子 -->
    <div
      style="display:flex;"
      class="avue-tags__box"
      :class="{ 'avue-tags__box--close': !website.isFirstPage }"
    >
      <el-tabs
        class="tags_tab"
        v-model="active"
        closeable
        @tab-click="changeTag"
        @edit="menuTag"
      >
        <el-tab-pane
          :key="item.value"
          v-for="item in tagList"
          :label="getLable(item)"
          :name="item.label"
          :closable="
            (tagList && tagList.length > 1 && !hasHomeTag()) ||
              (hasHomeTag() && getLable(item) !== '首页')
          "
        ></el-tab-pane>
      </el-tabs>
      <el-dropdown class="avue-tags__menu">
        <el-button class="avue-tags__menu_mini" size="mini">
          {{ $t("i18n_more") }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="closeOthersTags">
            {{ $t("i18n_close") }}
          </el-dropdown-item>
          <el-dropdown-item
            v-if="is_purchaser === '1'"
            @click.native="closeAllTags"
          >
            {{ $t("i18n_Show_home") }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { routerGo } from "@/util/utils.js"; // 引入跨应用路由跳转
import { setStore, getStore, removeStore } from "@/util/store";
import store from "../store";


export default {
  name: "Tags",
  data() {
    return {
      active: "",
      activeTag: {},
      switchTag: false,
      is_purchaser: "" // 0供应商  1采购端
    };
  },
  mounted() {
    this.setActive();
    this.default_lang = store.state.appstore.language;

    this.$root.$on("openTag", this.newTag);
    const userInfo = getStore({ name: "userInfo" }) || {};
    this.is_purchaser = userInfo.is_purchaser;
  },
  unmounted() {
    this.$root.$off("openTag", this.newTag);
  },
  watch: {
    tag() {
      // if(val){
      //   routerGo( val.href,val.title);
      //    this.$root.$emit("openTag", {
      //   label: val.title,
      //   value: val.href,
      // });
      // }
      this.setActive();
    },
    $route(to, from) {
      if (!this.switchTag && to.path === from.path) {
        const tag = this.activeTag;
        tag.value = to.fullPath;
        this.$store.commit("UPDATE_TAG", tag);
      }
    },
    appLoading(newVal) {
      if (!newVal) {
        this.loadedTag();
      }
    },
    // openTag: {
    //   handler(val) {
    //     console.log("&&&&&&&&&&&&&&&&&");
    //     console.log(val);
    //   },
    //   immediate: true,
    //   deep: true
    // }
    isTag: {
      handler(val) {
        routerGo(val.href, val.title);
        if (val.href === "/vendor/#/wel" && val.title === "首页") {
          this.handleHomePageTag({
            label: val.title,
            value: val.href
          });
        } else {
          this.$root.$emit("openTag", {
            label: val.title,
            value: val.href
          });
        }
      }
    }
    //       routerGo(newval.href, newval.title);
    //       // this.openNewTag(newval);
    //           //   this.$root.$emit("openTag", {
    //           //   label: newval.title,
    //           //   value: newval.href,
    //           // });
    //       // this.$store.dispatch("CLOSE_TAG", false);
    //     }
    //   },
    // },
  },
  computed: {
    ...mapGetters([
      "tagWel",
      "tagList",
      "tag",
      "website",
      "appLoading",
      "setNewOpen"
    ]),
    tagLen() {
      return this.tagList.length || 0;
    },
    isTag() {
      return this.setNewOpen;
    }
  },
  methods: {
    // 激活当前选项
    ...mapMutations(["menu/SET_OPEN_MENU"]),
    setActive(tag = this.tag) {
      // const item = getStore({ name: "tag" });
      this.active = tag.label;
      this.activeTag = tag;
    },
    menuTag(value, action) {
      if (action === "remove") {
        let { tag, key } = this.findTag(value);
        this.$store.commit("DEL_TAG", tag);
        if (tag.value === this.tag.value) {
          tag = this.tagList[key === 0 ? key : key - 1]; // 如果关闭本标签让前推一个
          this.openTag(tag);
          this["menu/SET_OPEN_MENU"](tag.id);
        }
        // 添加
        if (value === "供应商特批报表") {
          removeStore({ name: "supplierSpecial" });
        }
        if (value === "资质到期预警报表") {
          removeStore({ name: "aptitudeWarning" });
        }
        if (value === "代理商授权函预警报表") {
          removeStore({ name: "agentAuth" });
        }
        if (value === "合格供应商清单") {
          removeStore({ name: "qualifiedSupplier" });
        }
        if (value === "供应商联系人信息表") {
          removeStore({ name: "supplierContacts" });
        }
        if (value === "供应商特批报表") {
          removeStore({ name: "supplierSpecial" });
        }
        if (value === "客指供应商报表") {
          removeStore({ name: "customSupplier" });
        }
      }
    },
    newTag(item) {
      let tag = this.findTag(item.label).tag;
      // 如果是新TAG
      if (!tag) {
        const isNewApp = this.isNewApp(item);
        tag = item;
        if (isNewApp) {
          this.switchTag = true;
          setStore({ name: "loadingTag", content: tag });
          this.openPage(tag);
        } else {
          this.openNewTag(item);
          removeStore({ name: "loadingTag" });
        }
      } else {
        removeStore({ name: "loadingTag" });
        this.openTag(item);
      }
    },
    isNewApp(newItem, oldItem = this.activeTag) {
      const newApp = newItem.value.split("/#/")[0];
      const oldApp = oldItem.value.split("/#/")[0];
      return newApp !== oldApp;
    },
    loadedTag() {
      const item = getStore({ name: "loadingTag" });
      // 查找到正加载的应用，设置为新增TAG
      if (item) {
        this.setActive(item);
        this.$store.commit("ADD_TAG", item);
        removeStore({ name: "loadingTag" });
        setTimeout(() => {
          this.switchTag = false;
        }, 100);
      } else {
        // this.setActive(this.currentTag);
      }
    },
    openPage(tag) {
      // 手动触发跳转
      this.switchTag = true;
      routerGo(tag.value, tag.label);
    },
    openNewTag(item) {
      this.$store.commit("ADD_TAG", item);
      this.setActive(item);
      this.openPage(item);
      setTimeout(() => {
        this.switchTag = false;
      }, 100);
    },
    openTag(item) {
      this.$store.commit("SET_TAG", item);
      this.setActive(item);
      this.openPage(item);
      setTimeout(() => {
        this.switchTag = false;
      }, 100);
    },
    changeTag(item) {
      let tag;
      if (item.label) {
        tag = this.findTag(item.label || item.i18nKey).tag;
        this.$store.commit("SET_TAG", tag);
        this.setActive(tag);
      } else {
        tag = item;
      }
      this.openPage(tag);
      this["menu/SET_OPEN_MENU"](tag.id);
      setTimeout(() => {
        this.switchTag = false;
      }, 100);
    },
    closeOthersTags() {
      const supplierSpecialTag = getStore({ name: "supplierSpecial" }) || {};
      const aptitudeWarningTag = getStore({ name: "aptitudeWarning" }) || {};
      const agentAuthTag = getStore({ name: "agentAuth" }) || {};
      const qualifiedSupplierTag =
        getStore({ name: "qualifiedSupplier" }) || {};
      const supplierContactsTag = getStore({ name: "supplierContacts" }) || {};
      const customSupplierTag = getStore({ name: "customSupplier" }) || {};
      const value = this.activeTag.label;
      if (value === "供应商特批报表") {
        // removeStore({ name: "supplierSpecial" });
        if (Object.getOwnPropertyNames(aptitudeWarningTag).length !== 0) {
          removeStore({ name: "aptitudeWarning" });
        }
        if (Object.getOwnPropertyNames(agentAuthTag).length !== 0) {
          removeStore({ name: "agentAuth" });
        }
        if (Object.getOwnPropertyNames(qualifiedSupplierTag).length !== 0) {
          removeStore({ name: "qualifiedSupplier" });
        }
        if (Object.getOwnPropertyNames(supplierContactsTag).length !== 0) {
          removeStore({ name: "supplierContacts" });
        }
        if (Object.getOwnPropertyNames(customSupplierTag).length !== 0) {
          removeStore({ name: "customSupplier" });
        }
      }
      if (value === "资质到期预警报表") {
        //  removeStore({ name: "aptitudeWarning" });
        if (Object.getOwnPropertyNames(supplierSpecialTag).length !== 0) {
          removeStore({ name: "supplierSpecial" });
        }
        if (Object.getOwnPropertyNames(agentAuthTag).length !== 0) {
          removeStore({ name: "agentAuth" });
        }
        if (Object.getOwnPropertyNames(qualifiedSupplierTag).length !== 0) {
          removeStore({ name: "qualifiedSupplier" });
        }
        if (Object.getOwnPropertyNames(supplierContactsTag).length !== 0) {
          removeStore({ name: "supplierContacts" });
        }
        if (Object.getOwnPropertyNames(customSupplierTag).length !== 0) {
          removeStore({ name: "customSupplier" });
        }
      }
      if (value === "代理商授权函预警报表") {
        // removeStore({ name: "agentAuth" });
        if (Object.getOwnPropertyNames(supplierSpecialTag).length !== 0) {
          removeStore({ name: "supplierSpecial" });
        }
        if (Object.getOwnPropertyNames(aptitudeWarningTag).length !== 0) {
          removeStore({ name: "aptitudeWarning" });
        }
        if (Object.getOwnPropertyNames(qualifiedSupplierTag).length !== 0) {
          removeStore({ name: "qualifiedSupplier" });
        }
        if (Object.getOwnPropertyNames(supplierContactsTag).length !== 0) {
          removeStore({ name: "supplierContacts" });
        }
        if (Object.getOwnPropertyNames(customSupplierTag).length !== 0) {
          removeStore({ name: "customSupplier" });
        }
      }
      if (value === "合格供应商清单") {
        //removeStore({ name: "qualifiedSupplier" });
        if (Object.getOwnPropertyNames(supplierSpecialTag).length !== 0) {
          removeStore({ name: "supplierSpecial" });
        }
        if (Object.getOwnPropertyNames(aptitudeWarningTag).length !== 0) {
          removeStore({ name: "aptitudeWarning" });
        }
        if (Object.getOwnPropertyNames(agentAuthTag).length !== 0) {
          removeStore({ name: "agentAuth" });
        }
        if (Object.getOwnPropertyNames(supplierContactsTag).length !== 0) {
          removeStore({ name: "supplierContacts" });
        }
        if (Object.getOwnPropertyNames(customSupplierTag).length !== 0) {
          removeStore({ name: "customSupplier" });
        }
      }
      if (value === "供应商联系人信息表") {
        // removeStore({ name: "supplierContacts" });
        if (Object.getOwnPropertyNames(supplierSpecialTag).length !== 0) {
          removeStore({ name: "supplierSpecial" });
        }
        if (Object.getOwnPropertyNames(aptitudeWarningTag).length !== 0) {
          removeStore({ name: "aptitudeWarning" });
        }
        if (Object.getOwnPropertyNames(agentAuthTag).length !== 0) {
          removeStore({ name: "agentAuth" });
        }
        if (Object.getOwnPropertyNames(qualifiedSupplierTag).length !== 0) {
          removeStore({ name: "qualifiedSupplier" });
        }
        if (Object.getOwnPropertyNames(customSupplierTag).length !== 0) {
          removeStore({ name: "customSupplier" });
        }
      }
      if (value === "客指供应商报表") {
        // removeStore({ name: "customSupplier" });
        if (Object.getOwnPropertyNames(supplierSpecialTag).length !== 0) {
          removeStore({ name: "supplierSpecial" });
        }
        if (Object.getOwnPropertyNames(aptitudeWarningTag).length !== 0) {
          removeStore({ name: "aptitudeWarning" });
        }
        if (Object.getOwnPropertyNames(agentAuthTag).length !== 0) {
          removeStore({ name: "agentAuth" });
        }
        if (Object.getOwnPropertyNames(qualifiedSupplierTag).length !== 0) {
          removeStore({ name: "qualifiedSupplier" });
        }
        if (Object.getOwnPropertyNames(supplierContactsTag).length !== 0) {
          removeStore({ name: "supplierContacts" });
        }
      }
      this.$store.commit("DEL_TAG_OTHER");
    },
   
    getLable(item) {
      switch (this.default_lang){
        case 'zh_cn':
          return item.label;
        case 'en':
          return item.ResourcesNameEn?item.ResourcesNameEn: item.label;
        default:
          return item.label;
      }
    },
    findTag(value) {
      let tag, key;
      this.tagList.map((item, index) => {
        if (item.label === value || this.$t(item.i18nKey) === value) {
          tag = item || this.$t(item.i18nKey);
          key = index;
        }
      });
      return { tag: tag, key: key };
    },
    closeAllTags() {
      this.$store.commit("DEL_ALL_TAG");
      const title = "测试";
      // 添加

      removeStore({ name: "supplierSpecial" });

      removeStore({ name: "aptitudeWarning" });

      removeStore({ name: "agentAuth" });

      removeStore({ name: "qualifiedSupplier" });

      removeStore({ name: "supplierContacts" });

      removeStore({ name: "supplierSpecial" });

      removeStore({ name: "customSupplier" });

      routerGo(this.tagWel.value, title);
    },
    handleHomePageTag(item) {
      // 处理某些情况下，首页tag缺失的情况
      if (
        !this.tagList ||
        this.tagList.length < 1 ||
        this.tagList.findIndex(it => it.label === "首页") === -1
      ) {
        const homePageObj = {
          title: "首页",
          url: "/vendor/#/wel",
          i18nkey: "i18n_index",
          value: "/vendor/#/wel",
          label: "首页"
        };
        this.$store.commit("ADD_TAG", homePageObj);
        this.setActive(item);
      } else {
        this.$root.$emit("openTag", item);
      }
    },
    hasHomeTag() {
      if (!this.tagList) {
        return false;
      }
      const index = this.tagList.findIndex(
        item => this.getLable(item) === "首页"
      );

      return index !== -1;
    }
  }
};
</script>
<style lang="scss" scoped>
.top-tags {
  margin: 0 10px 0 20px;
}
.avue-tags {
  height: 34px;
  overflow: hidden;
}
.avue-tags__menu {
  /* float: right; */
  width: 80px;
  height: 30px;
  line-height: 24px;
  /* margin-top: -50px;
  margin-right: 10px; */
}
.avue-tags__menu_mini{
  padding: 5px 10px;
}
.avue-tags .el-tabs__header {
  margin: 0 !important;
}
.avue-tags .tags_tab {
  flex: 1;
}
.avue-tags .el-tabs--card > .el-tabs__header {
  border-bottom: 0;
}
/deep/ .el-tabs__nav-wrap::after{
  background-color: transparent;
}
/deep/ .el-tabs__item{
  height: 34px !important;
  line-height: 34px !important;
}
</style>
